import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigFooterBlockConfig } from '@front-platform/content-builder';
import { bigFooterBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input, computed } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface BigFooterBlockRuntimeConfig {
  'columns'?: unknown[];
  'left_body'?: unknown[];
}

export type BigFooterBlockConfigInput = Partial<
  Omit<BigFooterBlockConfig, keyof BigFooterBlockRuntimeConfig> & BigFooterBlockRuntimeConfig
>;
export type BigFooterBlockResolvedConfig = Omit<
  BigFooterBlockConfig,
  keyof BigFooterBlockRuntimeConfig
> &
  Partial<BigFooterBlockRuntimeConfig>;
export interface BigFooterBlockContract extends ConfigComponentContract<
  BigFooterBlockConfigInput,
  BigFooterBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-footer-block',
  templateUrl: './big-footer-block.component.html',
  standalone: false,
})
export class BigFooterBlockComponent implements BigFooterBlockContract {
  readonly config = input<BigFooterBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    BigFooterBlockConfig,
    BigFooterBlockRuntimeConfig
  >(bigFooterBlockResolveConfig, () => ({ config: this.config() }));
  readonly columns = computed(() => this.resolvedConfig()['columns'] as unknown as unknown[]);
  readonly leftBody = computed(() => this.resolvedConfig()['left_body'] as unknown as unknown[]);
  readonly colors = computed(() => {
    const raw = this.resolvedConfig()['colors'];
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
      return {};
    }
    const colors = raw as Record<string, unknown>;
    return {
      backgroundColor: (colors['background_color'] ?? colors['backgroundColor']) as
        | IContentBuilderFieldColor
        | undefined,
    };
  });
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigFooterBlockComponent, { 'keyAliases': {} });
